import {Card, Col, Row} from "reactstrap";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {ToCustomDecimal} from "../../AppSystem/Helpers/ToCustomDecimal";
import {ChangeDateFormat} from "../../Common/Helpers/ChangeDateFormat";

export function CustomReimbursementFixedView({data, editMode, onClickDelete, onClickEdit, isFixed = false, dataFixed = null }) {
    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);

    const fixedSignature = isFixed
        ? `${dataFixed?.id ?? ''}|${dataFixed?.salaryDate ?? ''}|${dataFixed?.amount ?? 0}|${dataFixed?.type ?? ''}`
        : (Array.isArray(data)
            ? data
                .map(item => `${item?.id ?? ''}|${item?.salaryDate ?? ''}|${item?.amount ?? 0}|${item?.type ?? ''}`)
                .join('||')
            : '');

    useEffect(() => {
        if (Array.isArray(data) && data.length > 0) {
            data.sort((a, b) => new Date(a.salaryDate) - new Date(b.salaryDate));
        }
    }, [data]);

    useEffect(() => {
        setIsExpanded(false);
    }, [fixedSignature]);

    const isReadOnlyProceeding = editMode === undefined && !onClickDelete && !onClickEdit && !isFixed;

    if (isReadOnlyProceeding) {
        const list = Array.isArray(data) ? data : (data ? [data] : []);
        if (list.length === 0) return null;

        return (
            <div className="reimbursement-section-card">
                <div className="reimbursement-section-title rokkitt-font">{t('reimbursement.salary')}</div>
                <div className="reimbursement-fields">
                    {list.map((item, index) => {
                        const isFixedType = item?.type === 'Fixed';
                        const typeLabel = isFixedType ? t('reimbursement.fixed') : t('reimbursement.movable');
                        const hoursValue = item?.hours ?? 0;
                        const amountValue = item?.amount ?? 0;
                        return (
                            <div key={`fixed-proceeding-${item?.id ?? index}`}>
                                <div className="reimbursement-field">
                                    <div className="reimbursement-field-label">{t('modelLabel.type')}</div>
                                    <div className="reimbursement-field-value">{typeLabel}</div>
                                </div>
                                {hoursValue !== 0 && (
                                    <div className="reimbursement-field" style={{ marginTop: 12 }}>
                                        <div className="reimbursement-field-label">{t('modelLabel.hours')}</div>
                                        <div className="reimbursement-field-value">{hoursValue}</div>
                                    </div>
                                )}
                                <div className="reimbursement-divider" />
                                <div className="reimbursement-field">
                                    <div className="reimbursement-field-label">{t('modelLabel.grossAmount')}</div>
                                    <div className="reimbursement-big-value">
                                        {ToCustomDecimal(amountValue)} {t('modelLabel.kr')}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    const totalAmount = isFixed
        ? (dataFixed?.amount ?? 0)
        : (data?.reduce((sum, item) => sum + (item?.amount ?? 0), 0) ?? 0);

    const itemsToShow = isFixed ? (dataFixed ? [dataFixed] : []) : (data ?? []);

    const canEdit = isFixed
        ? (dataFixed?.status === 'Förslag' && editMode !== true)
        : ((itemsToShow[0]?.status === 'Förslag' || itemsToShow[0]?.status === "") && editMode !== true);

    return (
        <div className="crv-card-outer">
            <div className="crv-header" onClick={() => setIsExpanded(prev => !prev)}>
                <div className="crv-header-left">
                    <i className="bx bx-purchase-tag crv-header-icon" />
                    <span className="crv-header-label">{t('reimbursement.salary')}</span>
                </div>
                <div className="crv-header-right">
                    {!isExpanded && (
                        <span className="crv-header-amount">{ToCustomDecimal(totalAmount)} kr</span>
                    )}
                    <i className={`bx ${isExpanded ? "bx-chevron-up" : "bx-chevron-down"} crv-chevron`} />
                </div>
            </div>

            <div className="crv-collapse" style={{ maxHeight: isExpanded ? "500px" : "0px" }}>
                <div className="crv-collapse-inner">
                    <div className={`crv-inner-card ${canEdit ? "crv-inner-card-with-buttons" : ""}`}>
                        {itemsToShow.map((item, index) => (
                            <div key={`item-${index}`} className="crv-row" style={{ paddingTop: index > 0 ? 8 : 0 }}>
                                <span className="crv-label">
                                    {item?.type === 'Fixed'
                                        ? t('reimbursement.fixed')
                                        : `${t('modelLabel.hours')}: ${item?.hours ? ToCustomDecimal(item?.hours) : 0}`
                                    }
                                </span>
                                <span className="crv-value-bold">
                                    {item?.amount ? ToCustomDecimal(item?.amount) : 0} kr
                                </span>
                            </div>
                        ))}
                    </div>

                    {canEdit && (
                        <div className="crv-action-buttons">
                            <button type="button" onClick={() => onClickDelete()} className="crv-btn-action">
                                <i className="bx bx-trash-alt crv-icon-delete" />
                            </button>
                            <button type="button" onClick={() => onClickEdit(isFixed ? null : itemsToShow[0])} className="crv-btn-action">
                                <i className="bx bxs-pencil crv-icon-edit" />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}